<template>
  <div class="tutorials">
    <div class="topInfo" :class="lan == 'ar' ? 'ar' : ''">
      <img class="logo" src="../assets/images/mlbb_logo.png" alt="" />
      <span class="logoInfo"></span>
      <span class="logo_mcc"></span>
      <div class="lan" @click="openLan">{{ lanText }}</div>
    </div>
    <div class="joinUs" @click="openJoin">
      <img src="../assets/images/join_us.png" alt="" />
      <p v-if="lan != 'mm'">{{ $t("message.strid4") }}</p>
    </div>
    <Title :titleText="$t('message.strid6')"></Title>
    <div class="viedoList">
      <div class="item" v-for="item in study_video" :key="item">
        <div class="pic" @click="openVideo(item.url)">
          <img :src="interceptFn(item.img)" alt="" />
        </div>
        <div class="info">
          <span class="name">{{ item.title }}</span>
        </div>
      </div>
      <!-- <div class="item">
        <div class="pic more" :class="lan == 'ar' ? 'ar' : ''">
          <span>more</span>
          <div class="morePic"></div>
        </div>
        <div class="info">
          <span class="name">KOL name</span>
        </div>
      </div> -->
    </div>

    <IframeViedo
      v-if="showIframe"
      @close="closeVideo"
      :list="iframeSrc"
    ></IframeViedo>
    <Lanbox
      v-if="showlanBox"
      :lan="lan"
      :flag="flag"
      @chose="choseLan"
      @close="closeLan"
    ></Lanbox>
    <Nav
      :showBack="true"
      :router="'tutorials'"
      :lan="lan"
      @open="openJoin"
    ></Nav>
    <joinBox v-if="showJoinBox" :lan="lan" :list="join_us" @close="closeJoin"></joinBox>
  </div>
</template>

<script>
import { getStudyVideoList } from "@/proxy/index";

export default {
  components: {
    Lanbox: () => import("@/components/lanBox"),
    Title: () => import("@/components/Title"),
    IframeViedo: () => import("@/components/iframeViedo"),
    Nav: () => import("@/components/nav"),
    joinBox: () => import("@/components/joinBox"),
  },
  data() {
    return {
      showlanBox: false,
      showJoinBox: false,
      showIframe: false,
      iframeSrc:
        "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fmobilelegendsgame%2Fvideos%2F681175045899935%2F&show_text=false&width=560",
      languageList: [
        {
          label: "EN",
          value: "en",
        },
        {
          label: "AR",
          value: "ar",
        },
        // {
        //   label: "ES",
        //   value: "es",
        // },
        {
          label: "MM",
          value: "mm",
        },
        {
          label: "MY",
          value: "my",
        },
        {
          label: "KH",
          value: "kh",
        },
        // {
        //   label: "BR",
        //   value: "pt_BR",
        // },
        {
          label: "ID",
          value: "id",
        },
        {
          label: "PH",
          value: "ph",
        },
      ],
      lan: "en",
      lanText: "EN",
      web_title: "",
      study_video: "",
      join_us: "",
      watchTime: 0
    };
  },
  methods: {
    interceptFn (url) {
      return url.split('?')[0] || url
    },
    getParam() {
      getStudyVideoList({ lang: this.lan })
        .then((res) => {
          if (res.code == 0) {
            var data = res.data;
            this.study_video = data.study_video;
            this.web_title = data.web_title;
            this.join_us = data.join_us;
            // this.orient();
          }
        })
        .catch(() => {
          //
          // this.orient();
        });
    },
    openLan() {
      this.showlanBox = true;
    },
    closeLan() {
      this.showlanBox = false;
    },
    openJoin() {
      this.$mlog.visitLog({
        behavior: "click",
        type: 'join_nav'
      })
      this.showJoinBox = true;
    },
    closeJoin() {
      this.showJoinBox = false;
    },
    openVideo(link) {
      this.watchTime = new Date().getTime()
      this.showIframe = true;
      this.iframeSrc = link;
      this.$mlog.visitLog({
        behavior: "click",
        type: 'tutorial',
        lang: this.$i18n.locale,
        url: link
      })
      // "https://www.youtube.com/embed/lx6vosPUrHU"
    },
    closeVideo() {
      const time = new Date().getTime() - this.watchTime
      this.showIframe = false;
      if (time >= 1000) {
        this.$mlog.visitLog({
          behavior: "watch",
          type: 'tutorial',
          lang: this.$i18n.locale,
          time,
          url: this.iframeSrc
        })
      }
      // this.mySwiper.autoplay.start();
    },
    choseLan(name, value) {
      this.lan = name;
      this.lanText = value;
      this.$i18n.locale = name;
      this.showlanBox = false;
      this.getParam();
      // this.orient();
      window.localStorage.setItem("Creatorlang", this.lan);
    },
    // orient() {
    //   if (window.orientation === 180 || window.orientation === 0) {
    //     console.log("竖屏");
    //     this.orientation = false;
    //     this.slognImg = this.web_s_pic;
    //   }
    //   if (window.orientation === 90 || window.orientation === -90) {
    //     console.log("横屏");
    //     this.orientation = true;
    //     this.slognImg = this.web_h_pic;
    //   }
    // },
  },
  mounted() {
    if (this.$route.query.lang) {
      const i = this.languageList.find(
        (item) => item.value == this.$route.query.lang
      );
      if (i) {
        this.lan = i.value;
        this.$i18n.locale = i.value;
        this.lanText = i.label;
        window.localStorage.setItem("Creatorlang", this.lan);
      }
      this.$router.push({ query: {} });
    } else {
      this.lan = "en";
      this.$i18n.locale = "en";
    }
    const lang = window.localStorage.getItem("Creatorlang");
    if (lang) {
      const i = this.languageList.find((item) => item.value == lang);
      if (i) {
        this.lan = i.value;
        this.$i18n.locale = i.value;
        this.lanText = i.label;
      }
    } else {
      this.lan = "en";
      this.$i18n.locale = "en";
      window.localStorage.setItem("Creatorlang", this.lan);
    }
    this.getParam();

    window.addEventListener("orientationchange", this.orient, false);
  },
};
// };
</script>

<style lang="scss" scoped>
@import "@/assets/style/activity.scss";
</style>
